import axios from "axios";

const BASE_URL = `https://${process.env.REACT_APP_DOMAIN}/api/v1`;

class AiChatApi {
  static sendMessage = ({ locationId, param, cancelToken }) => {
    return axios({
      method: "POST",
      url: `${BASE_URL}/superhuman-chat/${locationId}/messages`,
      data: param,
      cancelToken,
    });
  };
  static updateContact = ({ locationId, param, cancelToken }) => {
    return axios({
      method: "POST",
      url: `${BASE_URL}/superhuman-chat/${locationId}/contact`,
      data: param,
      cancelToken,
    });
  };
  static checkMessageStatus = ({ locationId, idempotencyKey, cancelToken }) => {
    return axios({
      method: "GET",
      url: `${BASE_URL}/superhuman-chat/${locationId}/status/${idempotencyKey}`,
      cancelToken,
    });
  };
}

export default AiChatApi;
